export default class Rule {

}



// WEBPACK FOOTER //
// ./app/common/rule/rule.controller.js